<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت مزیت فروشگاهی </div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;مزیت جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.s_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.s_Id)" dark v-if="!item.s_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.s_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.s_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog fullscreen persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت مزیت جدید</span>
                              <span v-else>ویرایش مزیت  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md4 lg4 xl4 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;"><!--Register New Color From-->
                                    <v-text-field color="#2a2d45" outlined dense v-model="Title" label="عنوان" ></v-text-field>
                                    <v-text-field   color="#2a2d45" outlined dense v-model="SortField" label="ترتیب نمایش" ></v-text-field>
                                    <quill-editor placeholder="محتوای صفحه" label="محتوای صفحه" :content="PageContent"
                                    @change="({html})=>{PageContent = html}">
                                    </quill-editor>
                                    <f-up :OldFile="Image" @RetunedFileName="Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس اصلی"></f-up>
                                    <f-up :OldFile="Logo" @RetunedFileName="Logo = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="آیکون"></f-up>

                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="Status" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-btn style="margin-top:20px;" @click="registerItem" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md5 lg5 xl5 style="padding:15px;"><!--Row #2-->
                            <seo-form FileLoc="PRDCATSEOIMG" :Seo="SeoData" @SeoData="SeoChanged"></seo-form>
                        </v-flex>
                        <v-flex xs12 md3 lg3 xl3 style="padding:15px;"><!--Row #2-->
                           <v-layout row wrap>
                            <v-flex
                                xs12
                                sm12
                                md6
                                lg6
                                xl6
                                v-for="item in imageItems"
                                :key="item"
                                style="padding: 20px"
                            >
                                <v-card>
                                <v-overlay style="padding: 0px" absolute
                                    ><v-btn small text @click="deleteImageItem(item)"
                                    ><v-icon small>fa fa-trash</v-icon></v-btn
                                    ></v-overlay
                                >
                                <v-img :src="downloadServiceUrl + item" />
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 20px">
                                <v-card>
                                <v-overlay style="padding: 0px" absolute>
                                  <f-up :hideExternal="true" @RetunedFileName="PickImageName" Root="ELOGO" Folder="CONTENT" BtnTitle="آیکون"></f-up>
                                </v-overlay>
                                <v-img
                                    contain
                                    :src="require('../../../assets/blank-bg.png')"
                                />
                                </v-card>
                            </v-flex>
                           </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
            <template
      ><!--Select product image child-->
      <v-dialog v-model="SelectProductImageChild" max-width="500">
        <v-card>
          <v-card-text style="padding-top: 10px">
            <imgeditor
              @SavedFileName="PickImageName"
              :UploadUrl="uploadServiceUrl"
              FileLoc="CONTENT"
            ></imgeditor>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueEditor } from "vue2-editor";
import JsonExcel from 'vue-json-excel'
export default {
   name:"shopprofits",
   components: 
   {
      Loading,
      JsonExcel,
        VueEditor
    },
    data:()=> ({
        SelectProductImageChild:false,
        AttrType:"",
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        searchcategory:"",
        isLoadingItems:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"s_Title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"s_Sort",sortable:true,align:"right"},
            {text:"وضعیت",value:"s_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        Title:"",
        SortField:"",
        originalItems:[],
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "کد":"s_Id",
            "عنوان":"s_Title",
            "نوع مزیت":"s_Type",
            "استفاده در جستجو":"s_UseInSearch",
            "ترتیب نمایش":"s_SortField",
            "وضعیت":"s_Status"
        },
        uploadServiceUrl:"",
        Image:"",
        Logo:"",
        PageContent:"",
        Status:true,
        SeoData:{},
        seo:{},
        imageItems:[],
        UploadedProductIgGallery:"",
        downloadServiceUrl:""
    }),
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadItems();
        }
    },
    async created()
    {
        let vm = this;
        vm.uploadServiceUrl = ApiUrl.registerPcImg;
        vm.downloadServiceUrl = ApiUrl.ContentLogo;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadItems();
    },
    methods:{   
        PickImageName(fname) {
        this.imageItems.push(fname);
        },
        async deleteImageItem(item) {
            let vm = this;
            vm.imageItems = vm.imageItems.filter((i) => i !== item);
            await axios
                .post(ApiUrl.removeNoticesGalleryChild, {
                DataUrl: item,
                Loc: vm.UploadProductImgEndPoint,
                })
                .then((res) => {
                if (res.data.status) {
                    MSGHNDL.OK(res.data.msg);
                    
                } 
                })
                .catch((err) => {
                console.error(err);
                });
        },

        SeoChanged(data)
        {
            this.seo = data;
        },
        getAttrText(v)
        {
            let vm = this;
            let title = "";
            vm.AttributeTypeItems.forEach(i=>{
                if(i.value == v)
                {
                    title= i.text;
                }
            });
            return title;
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.S_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteService,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.S_Id = id;
            await axios.post(ApiUrl.ActiveService,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.S_Id = id;
            await axios.post(ApiUrl.DisableService,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.Title = "";
            vm.SortField = "";
            vm.Email = "";
            vm.Phone = "";
            vm.AttrStatus = true;
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(Model)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.Title = Model.s_Title ;
            vm.SortField = Model.s_Sort;
            vm.Image = Model.s_Image;
            vm.Logo = Model.s_Icon;
            vm.Status = Model.s_Status;
            vm.PageContent = Model.s_Content;
            vm.imageItems = (Model.s_ImageGallery != "" && Model.s_ImageGallery != ",") ? Model.s_ImageGallery.split(','):[];
            vm.SeoData = JSON.parse(Model.s_Seo);
            vm.inEditingItem = true;
            vm.EditSelectedItem = Model;
        },
        async loadItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadServices+"/2/"+vm.LANG).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async registerItem()
        {
            let vm = this;
            let Model = {};
            Model.S_Title = vm.Title;
            Model.S_Sort = vm.SortField;
            Model.S_Image = vm.Image;
            Model.S_Icon = vm.Logo;
            Model.S_Status = vm.Status;
            Model.S_Content = vm.PageContent;
            Model.S_Type = 2;
            Model.S_ImageGallery = vm.imageItems.length > 0 ?  vm.imageItems.join(',') : "";
            Model.S_Seo = JSON.stringify(vm.seo);
            Model.Lang = vm.LANG;
            let url = ApiUrl.AddService;
            if(vm.inEditingItem)
            {
                Model.S_Id = vm.EditSelectedItem.s_Id;
                url = ApiUrl.UpdateService;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadItems();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>